import { FirestoreDataConverter } from 'firebase/firestore';
import { IFeedback } from '../Feedback';

interface IMessage {
    subject: string,
    html: string,
}

const isIMessage = (message: any): message is Message => {
    return "subject" in message && 
        typeof(message.subject) === 'string' &&
        "html" in message &&
        typeof(message.html) === 'string';
}

class Message implements IMessage {
    subject: string;
    html: string;

    constructor({subject, html}: IMessage){
        this.subject = subject;
        this.html= html;
    }
}

export class FeedbackMessage extends Message {
    constructor(feedback: IFeedback, baseUrl: string){
        let html = FeedbackMessage.feedbackMail(feedback, baseUrl);
        super({subject: 'Didacto', html})
    }

    static feedbackMail = ({name, comment, id="", wantsNewsletter=false, email}: IFeedback, baseUrl: string) => {
        return (
            `Hallo ${name}<br/><br/>` +
            'Wir haben deine Nachricht erhalten und werden dich informieren, sobald es Neuigkeiten zu didacto gibt.<br/>' +
            'Bei konkreten Fragen werden wir dir so bald wie möglich persönlich antworten. <br/><br/>' +
            'Liebe Grüsse,<br/><br/>' +
            'Tobias und das didacto Team<br/><br/><br/><br/>' +
            'Erhaltene Nachricht: <br/>' +
            comment +
            FeedbackMessage.unsubFragment(id, wantsNewsletter, baseUrl, email)
        )
    }

    static unsubFragment = (id: string, wantsNewsletter: boolean, baseUrl: string, email: string) => {
        if (wantsNewsletter === false || id === undefined){
            return "";
        }
        const unsubURL = `${baseUrl}/api/unsubscribe?feedbackid=${id}&email=${email}`;
        return `<br/><br/>Der Newsletter kann <a href="${unsubURL}">hier</a> abbestellt werden.`;
    }
}

export class ActivationMessage extends Message {
    constructor(){
        let html = ActivationMessage.activationMail();
        super({subject: "didacto – Account freigeschaltet", html})
    }
    static activationMail = () => {
        return `<html>
        <head>
            <meta name="viewport" content="width=device-width">
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
            <title>Didacto Newsletter</title>
        
        </head>
        
        <body width="100%" style="margin: 0;background-color:#EBEEF2;">
            <style type="text/css">
                * {
                    font-family: 'TisaSansPro', Roboto, Helvetica, sans-serif;
                    font-size: 18px;
                }
        
                body {
                    background-color: #FFFFFF;
                }
        
                @font-face {
                    font-family: TisaSansPro;
                    src: url("https://firebasestorage.googleapis.com/v0/b/didacto-p.appspot.com/o/public%2Fnewsletter%2FTisaSansPro?alt=media") format("woff");
                }
        
                @font-face {
                    font-family: TisaPro;
                    src: url("https://firebasestorage.googleapis.com/v0/b/didacto-p.appspot.com/o/public%2Fnewsletter%2FTisaPro.woff?alt=media") format("woff");
                }
        
                a {
                    text-decoration: none;
                    color: #888888;
                }
        
                li {
                    line-height: 2;
                    border-bottom: 1px solid lightgray;
                }
        
                a:hover {
                    color: #666666;
        
                } 
        
                .button {
                    font-size: 16px;
                    margin: 0;
                    border: 0;
                    outline: none;
                    box-sizing: content-box;
                    cursor: pointer;
                    padding: 4px 20px;
                    font-family: TisaSansPro;
                    font-weight: bold;
                    -webkit-border-radius: 24px 24px 24px 0;  
                    -moz-border-radius: 24px 24px 24px 0;   
                    border-radius: 24px 24px 24px 0; 
                    background-color: #B14E79;
                    color: #FFFFFF;  
                }
        
                .button:hover, .button:active {
                    background-color:  #994469;
                }
        
            </style>
            <table style="background-color:#FFFFFF; width: 100%; height: 100%; max-width: 600px; margin: auto; border-collapse: collapse;" >
                <tr>
                
                    <td style="text-align: right; padding: 40px 0 10px 0; background-color: #EBEEF2">
                        <img width="180px" height="auto" 
                            src="https://firebasestorage.googleapis.com/v0/b/didacto-p.appspot.com/o/public%2Fnewsletter%2Fdidacto_logo_newsletter.png?alt=media"
                            " alt="Didacto Logo"/>
                    </td>
                </tr>
                
                <tr style="background-color: #FFFFFF;">
                    <td style="text-align: left; padding: 30px;">
                        Deine Produkte von didacto stehen nun zum Download bereit. Wenn du eingeloggt bist, findest du sie unter <a href="https://www.didacto.ch/home">didacto.ch</a> bei deinen Produkten.<br/>
                        Wir empfehlen dir, die Datei Readme sorgfältig durchzulesen. Darin findest du wichtige Hinweise, unter anderem zum korrekten Ausdruck der Lernstandserfassungen. Die Datei findest du in deinem Ordner Mathe-Package.<br/>
                        Wir wünschen dir viel Freude an didacto.<br/><br/>
                        Liebe Grüsse<br/>
                        Dein didacto-Team
                    </td>
                </tr>
                
                
                
                <tr style="background-color: #B14E79; ">
                    <td style="text-align: center; padding: 30px; color: #FFFFFF; ">
                        <h3 style="font-family: TisaPro; font-size: 30px; font-weight: 200; padding:0px; margin: 0px">Mathematik</h3>
                        <h5 style="font-family: TisaPro; padding: 0px; margin: 0px">kompetenzorientiert beurteilen und individuell fördern</h5>
                    </td>
                </tr>
              
                <tr>
                    <td style="text-align: center; padding: 20px; color: #32507E; font-size: 12px; background-color: #EBEEF2">
                        didacto <br/> hoch5 GmbH, Hinterhubstrasse 4, 8413 Neftenbach, <a href="mailto:info@didacto.ch" style="color: #32507E; font-size: 12px;">info@didacto.ch</a>
                    </td>
                </tr>
            </table>
        
        </body>
        </html>`;
    }
}

export const isIMail = (mail: any): mail is IMail => {
    return "to" in mail && 
        typeof(mail.to) === 'string' &&
        "message" in mail &&
        isIMessage(mail.message) &&
        "bcc" in mail &&
        typeof(mail.bcc) === 'string';
}

interface IMail {
    to: string,
    bcc: string,
    message: Message,
}

export class Mail implements IMail {
    to: string
    bcc: string
    message: Message

    constructor({to, bcc, message}: IMail){
        this.to = to;
        this.bcc = bcc;
        this.message = message;
    }
}

export const MailConverter: FirestoreDataConverter<Mail> = {
    toFirestore: (mail: Mail) => {
        const message = mail.message;
        return {
            to: mail.to,
            bcc: mail.bcc,
            message: {
                subject: message.subject, 
                html: message.html,
            }
        }
    },
    fromFirestore: (snapshot): Mail => {
       const data = snapshot.data();
       if (isIMail(data)){
           return new Mail(data);
       } else {
           throw new Error(`Malformed mail record:\n{data}`);
       }
    }
}